export default "__VITE_ASSET__DUXE0AR8__"